<template>
    <div class="w-full">

        <div class="flex justify-between sm:hidden m-5">
            <div>
                <i class="fal fa-bars fa-lg" @click="onMenuClick"></i>
            </div>
            <div class="text-xl text-slate-600 font-bold tracking-tight ">Tailwind tools</div>
            <div></div>
        </div>

        <router-view/>

        <slide-out-menu v-if="this.viewModel.showMenu" :view-model="viewModel"></slide-out-menu>
    </div>
</template>

<script>
import SlideOutMenu from "./SlideOutMenu.vue";
export default {
    name: 'MainContainer',
    components: {SlideOutMenu},
    props: ['prop1', 'prop2'],
    data () {
        return {
            model: webase.model,
            viewModel: {
                showMenu: false
            }
        }
    },
    mounted () {
    },
    methods: {
        onMenuClick () {
            this.viewModel.showMenu = !this.viewModel.showMenu
        }
    }
}
</script>
